__turbopack_context__.v({
  "onDark": "iso-marks-module__W4nTtW__onDark",
  "onLight": "iso-marks-module__W4nTtW__onLight",
  "outline": "iso-marks-module__W4nTtW__outline",
});
